/**
 * Loại cột - xác định editor
 */
export default {
  // / Tất cả
  All: -1,
  // / Không chọn
  None: 0,
  // / Tạm ứng - Dự toán
  Advance: 1,
  // / Thực chi - Dự toán
  Spend: 2,
  // / Thanh toán tạm ứng kho bạc
  PayForAdvance: 3,
  // / Chi từ tạm ứng
  SpendForAdvance: 4,
  // / Nộp trả - Tạm ứng
  RefundAdvance: 5,
  // /  Nộp trả - Thực chi
  RefundExpense: 11,
  // / Ghi thu - Ghi chi
  ReceiptExpense: 6,
  // / Thu ngân sách xã hưởng 0%
  CommuneReceiptNonePercent: 7,
  // / Khôi phục
  RestorePlan: 8,
  // / Nhận dự toán bổ sung
  BUReceiveBudgetPlanAddition: 9,
  // / Điều chỉnh dự toán
  BUPlanAdjustment: 10,
  // / Nhận dự toán đầu năm
  BUReceiveBudgetPlan: 12,
  // / Hủy dự toán
  BUPlanCancel: 13,
  // / Lệnh chi tiền - Tạm ứng
  OrderAdvanced: 14,
  // / Lệnh chi tiền - Thực chi
  OrderSpend: 15,
};
